export default __webpack_public_path__ + "static/blog-2-c40dffe16f5cadada411402c4346ca58.jpg";